import { render, staticRenderFns } from "./StartPageBirthday.vue?vue&type=template&id=72a022e2&scoped=true&"
import script from "./StartPageBirthday.vue?vue&type=script&lang=js&"
export * from "./StartPageBirthday.vue?vue&type=script&lang=js&"
import style0 from "./StartPageBirthday.vue?vue&type=style&index=0&id=72a022e2&lang=scss&scoped=true&"
import style1 from "./StartPageBirthday.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a022e2",
  null
  
)

export default component.exports